document.querySelectorAll('.product-benefit').forEach(function(benefit) {
  benefit.addEventListener('click', function() {
    // Primero, ocultamos todas las vistas de la parte posterior y mostramos la delantera
    document.querySelectorAll('.front-view').forEach(function(frontView) {
      frontView.style.display = 'flex';
    });
    document.querySelectorAll('.back-view').forEach(function(backView) {
      backView.style.display = 'none';
    });

    // Luego, alternamos la visibilidad entre front-view y back-view solo para el clickeado
    const frontView = benefit.querySelector('.front-view');
    const backView = benefit.querySelector('.back-view');

    if (frontView.style.display === 'none') {
      frontView.style.display = 'flex';
      backView.style.display = 'none';
    } else {
      frontView.style.display = 'none';
      backView.style.display = 'flex';
    }
  });
});
